var _a, _b;
export var LabelByAssignmentStatus = (_a = {},
    _a["not_started" /* NotStarted */] = 'Not started',
    _a["in_progress" /* Active */] = 'Active',
    _a["scheduled" /* Scheduled */] = 'Scheduled',
    _a["completed" /* Ended */] = 'Ended',
    _a["canceled" /* Canceled */] = 'Canceled',
    _a["canceled_by_card" /* CanceledByCard */] = 'Canceled',
    _a["canceled_by_time" /* CanceledByTime */] = 'Canceled',
    _a["canceled_by_teacher" /* CanceledByTeacher */] = 'Canceled',
    _a["expired" /* Expired */] = 'Expired',
    _a);
export var LabelByStudentStatus = (_b = {},
    _b["not_started" /* NotStarted */] = 'not started',
    _b["in_progress" /* Active */] = 'in progress',
    _b["completed" /* Completed */] = 'completed',
    _b["expired" /* Expired */] = 'expired',
    _b["canceled_by_card" /* CanceledByCard */] = 'canceled',
    _b["canceled_by_time" /* CanceledByTime */] = 'canceled',
    _b["canceled_by_teacher" /* CanceledByTeacher */] = 'canceled by teacher',
    _b["canceled" /* Canceled */] = 'canceled',
    _b);
var isAssignmentStarted = function (status) {
    return ["in_progress" /* Active */].includes(status);
};
var isAssignmentCompleted = function (status) {
    return [
        "completed" /* Ended */,
        "canceled" /* Canceled */,
        "expired" /* Expired */,
    ].includes(status);
};
var isStudentAssignmentInProgress = function (status) { return ["in_progress" /* Active */].includes(status); };
var isStudentAssignmentFinished = function (status) {
    return [
        "completed" /* Completed */,
        "canceled_by_card" /* CanceledByCard */,
        "canceled_by_teacher" /* CanceledByTeacher */,
        "canceled_by_time" /* CanceledByTime */,
        "expired" /* Expired */,
    ].includes(status);
};
export { isAssignmentStarted, isAssignmentCompleted, isStudentAssignmentInProgress, isStudentAssignmentFinished, };
